import { FC } from "react";
import { JobQueue } from "./job-queues/jobQueue";
import { JobStatus } from "./jobStatus";
import moment from "moment";
import { QESTextArea } from "../shared/qes-standards";
import { JobCancel } from "./JobCancel";
import Job from "./job";
import { JobSummary } from "./jobListSummary";

export interface JobInfoProps {
  job: Job;
  jobSummary: JobSummary;
  jobQueueList: JobQueue[];
  jobIds: number[];
  onClose: () => void;
}

export const JobInfo: FC<React.PropsWithChildren<JobInfoProps>> = (props: JobInfoProps) => {
  return (<>
    <dl className="d-table mb-0">
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Type: </dt>
        <dd className="d-table-cell pl-2">{props.job.jobType}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s align-middle">Status: </dt>
        <dd className="d-table-cell pl-2 align-middle">
          {props.job.jobStatus}
        </dd>
        {(props.job.jobStatus === JobStatus.Started || props.job.jobStatus === JobStatus.Queued) && (
          <>
            <dd className="d-table-cell pl-2 align-middle">
              <div className="row">
                <JobCancel started={props.job.jobStatus === JobStatus.Started}
                  jobQueueList={props.jobQueueList}
                  jobIds={[props.job.jobId]}
                  onCompleted={props.onClose}
                />
              </div>
            </dd>
          </>
        )}
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Date Created: </dt>
        <dd className="d-table-cell pl-2">{moment.utc(props.job.dateCreated).local().format("L LT")}</dd>
      </div>
      {!!props.job.dateQueued ? (
        <div className="d-table-row">
          <dt className="d-table-cell label-s">Date Queued: </dt>
          <dd className="d-table-cell pl-2">{moment.utc(props.job.dateQueued).local().format("L LT")}</dd>
        </div>) : null
      }
      {!!props.job.dateStarted ? (
        <div className="d-table-row">
          <dt className="d-table-cell label-s">Date Started: </dt>
          <dd className="d-table-cell pl-2">{moment.utc(props.job.dateStarted).local().format("L LT")}</dd>
        </div>) : null
      }
      {!!props.job.dateFinished ? (
        <div className="d-table-row">
          <dt className="d-table-cell label-s">Date {props.job.jobStatus === JobStatus.Finished ? "Finished" : "Failed"}: </dt>
          <dd className="d-table-cell pl-2">{moment.utc(props.job.dateFinished).local().format("L LT")}</dd>
        </div>) : null
      }
      {!!props.job.dateCancelled ? (
        <div className="d-table-row">
          <dt className="d-table-cell label-s">Date Cancelled: </dt>
          <dd className="d-table-cell pl-2">{moment.utc(props.job.dateCancelled).local().format("L LT")}</dd>
        </div>) : null
      }
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Job Queue: </dt>
        <dd className="d-table-cell pl-2">{props.jobSummary.jobQueueName}</dd>
      </div>
      <div className="d-table-row">
        <dt className="d-table-cell label-s">Client: </dt>
        <dd className="d-table-cell pl-2">{props.jobSummary.clientName}</dd>
      </div>
      {!!props.jobSummary.workerRoleId ? (
        <div className="d-table-row">
          <dt className="d-table-cell label-s">Worker Host Name: </dt>
          <dd className="d-table-cell pl-2">{props.jobSummary.workerRoleId}</dd>
        </div>) : null
      }
    </dl>
    {!!props.job.payload ? (
      <QESTextArea
        containerClassName=""
        label="Payload:"
        testId={`job-details__payload`}
        value={props.job.payload}
        readOnly={true}
      />) : null
    }
    {!!props.jobSummary.errorMessage ? (
      <QESTextArea
        containerClassName=""
        label="Failure Message:"
        testId={`job-details__failure-message`}
        value={props.jobSummary.errorMessage}
        readOnly={true}
      />) : null
    }
    <a href={props.job.jobLogUrl} target="_blank" rel="noreferrer">View in Seq</a>
  </>);
}